module.exports = __webpack_public_path__ + "static/media/david-warner.0dfbf623.jpg";